export const socials = {
    okShare: {
        rbmail: {
            type: 'click',
            id: '28570622',
        },
    },
    vkShare: {
        rbmail: {
            type: 'click',
            id: '28570624',
        },
    },
};
